import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import LockIcon from "@material-ui/icons/Lock"; // ✅ AGREGADO: Para icono de tickets cerrados
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import WarningIcon from "@material-ui/icons/Warning"; // ✅ AGREGADO: Para icono de alerta
import Typography from "@material-ui/core/Typography"; // ✅ AGREGADO: Para mejor tipografía
import Box from "@material-ui/core/Box"; // ✅ AGREGADO: Para layout mejorado
import Radio from "@material-ui/core/Radio"; // ✅ AGREGADO: Para selección de opciones
import RadioGroup from "@material-ui/core/RadioGroup"; // ✅ AGREGADO: Para grupo de opciones
import FormControlLabel from "@material-ui/core/FormControlLabel"; // ✅ AGREGADO: Para labels de opciones
import FormControl from "@material-ui/core/FormControl"; // ✅ AGREGADO: Para control de formulario
import api from "../../services/api"; // ✅ AGREGADO: Para llamadas a la API

import {
  Add as AddIcon,
} from "@material-ui/icons";

import NewTicketModal from "../NewTicketModal";
import TicketsListCustom from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ConfirmationModal from "../ConfirmationModal"; // ✅ AGREGADO: Para confirmación de cerrar tickets
import SearchResultsPanel from "../SearchResultsPanel"; // ✅ AGREGADO: Para búsqueda global
// ✅ ELIMINADO: DuplicateTicketsCorrectionModal - Ya no se usa

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SocketContext } from "../../context/Socket/SocketContext";

import FilterPanel from "../FilterPanel";
import FilterListIcon from "@material-ui/icons/FilterList";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import BusinessIcon from "@material-ui/icons/Business";
import Chip from "@material-ui/core/Chip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles(theme => ({
	ticketsWrapper: {
		position: "relative",
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderRadius:0,
	},

	ticketsContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		height: "100%",
		minHeight: 0, // Importante para que flex funcione correctamente
		overflow: "hidden",
	},


	tabsHeader: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground,
	},

	tabsInternal: {
		flex: "none",
		backgroundColor: theme.palette.tabHeaderBackground
	},

	settingsIcon: {
		alignSelf: "center",
		marginLeft: "auto",
		padding: 8,
	},
  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#1e3a8a",
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "#10b981",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#10b981",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "#ef4444",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "#ef4444",
      color: "#FFF",
    },
    borderRadius: 30,
  },

  // ✅ CORREGIDO: Estilos para el buscador dinámicos según tema
  searchInputWrapperNew: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    borderRadius: "8px",
    padding: "8px 12px",
    margin: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    transition: "all 0.3s ease",
    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#fff',
      boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
    },
  },

  searchIconNew: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginRight: "8px",
    fontSize: "20px",
  },

  searchInputNew: {
    flex: 1,
    fontSize: "14px",
    color: theme.palette.text.primary,
    "& input": {
      padding: "4px 0",
      fontSize: "14px",
      color: theme.palette.text.primary,
    },
    "& input::placeholder": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: "14px",
    },
  },

  searchSwitchNew: {
    marginLeft: "8px",
    "& .MuiSwitch-thumb": {
      width: "16px",
      height: "16px",
    },
    "& .MuiSwitch-track": {
      height: "12px",
      borderRadius: "6px",
    },
  },

  // ✅ CORREGIDO: Estilos para la barra de herramientas dinámicos según tema
  quickActionsBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f8f9fa',
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    minHeight: "56px",
  },

  quickActionsLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  quickActionsRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5), // ✅ Agregar espaciado entre botones
  },

  // ✅ CORREGIDO: QuickActionButton dinámico según tema
  quickActionButton: {
    minWidth: "40px",
    height: "40px",
    borderRadius: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#fff',
    color: theme.palette.text.primary,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      borderColor: theme.palette.primary.main,
    },
  },

  // ✅ CORREGIDO: QuickActionIconButton dinámico según tema
  quickActionIconButton: {
    minWidth: "40px",
    height: "40px",
    borderRadius: "8px",
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#fff',
    color: theme.palette.text.primary,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      borderColor: theme.palette.primary.main,
    },
  },

	tab: {
		minWidth: 120,
		width: 120,
	},

	internalTab: {
		minWidth: 120,
		width: 120,
		padding: 5
	},

	ticketOptionsBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		background: theme.palette.optionsBackground,
		padding: theme.spacing(1),
	},

	ticketSearchLine: {
		padding: theme.spacing(1),
	},

	serachInputWrapper: {
		flex: 1,
		background: theme.palette.total,
		display: "flex",
		borderRadius: 40,
		padding: 4,
		marginRight: theme.spacing(1),
	},

	searchIcon: {
		color: "grey",
		marginLeft: 6,
		marginRight: 6,
		alignSelf: "center",
	},

	searchInput: {
		flex: 1,
		border: "none",
		borderRadius: 30,
	},

	insiderTabPanel: {
		height: '100%',
		marginTop: "-72px",
		paddingTop: "72px"
	},

	insiderDoubleTabPanel: {
		display:"flex",
		flexDirection: "column",
		marginTop: "-72px",
		paddingTop: "72px",
		height: "100%"
	},

	labelContainer: {
		width: "auto",
		padding: 0
	},
	iconLabelWrapper: {
		flexDirection: "row",
		'& > *:first-child': {
			marginBottom: '3px !important',
			marginRight: 16
		}
	},
	insiderTabLabel: {
		[theme.breakpoints.down(1600)]: {
			display:'none'
		}
	},
	smallFormControl: {
		'& .MuiOutlinedInput-input': {
			padding: "12px 10px",
		},
		'& .MuiInputLabel-outlined': {
			marginTop: "-6px"
		}
	}
}));

const TicketsManagerTabs = () => {
  const classes = useStyles();
  const theme = useTheme(); // ✅ Para acceder al tema y detectar dark mode
  const history = useHistory();
  
  // ✅ FUNCIÓN PARA DETERMINAR LA PESTAÑA CORRECTA SEGÚN EL TIPO DE TICKET (NO UTILIZADA)
  // const getTabForTicket = (ticket) => {
  //   if (ticket.contact && ticket.contact.isGroup) {
  //     // ✅ GRUPOS: Solo van a "GRUPOS" o "CERRADOS"
  //     return ticket.status === "closed" ? "closed" : "groups";
  //   } else {
  //     // ✅ CONTACTOS INDIVIDUALES: Flujo normal
  //     return ticket.status;
  //   }
  // };

  // ✅ FUNCIÓN PARA MANEJAR CAMBIOS DE ESTADO DE TICKETS (NO UTILIZADA)
  // const handleTicketStatusChange = (ticket, newStatus) => {
  //   const currentTab = getTabForTicket(ticket);
  //   const newTab = getTabForTicket({ ...ticket, status: newStatus });
  //   
  //   // ✅ Si el ticket cambia de pestaña, actualizar la vista
  //   if (currentTab !== newTab) {
  //     if (newTab === "groups") {
  //       setTabOpen("groups");
  //     } else if (newTab === "closed") {
  //       setTabOpen("closed");
  //     }
  //   }
  // };
  


  
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false); // ✅ AGREGADO: Para confirmación de cerrar tickets
  // ✅ ELIMINADO: duplicateTicketsModalOpen - Ya no se usa

  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  // const { profile } = user; // ✅ REMOVIDO: No se usa en este componente
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  // ✅ NUEVOS CONTADORES PARA PESTAÑAS MEJORADAS
  const [groupsCount, setGroupsCount] = useState(0);
  const [aiAgentsCount, setAiAgentsCount] = useState(0);
  const [allTicketsCount, setAllTicketsCount] = useState(0); // ✅ AGREGADO: Contador para vista "TODOS"

  // ✅ Inicializar con array vacío (sin filtro por defecto)
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);

  // ✅ ESTADO PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const [localSearchParam, setLocalSearchParam] = useState("");
  const [searchOnMessages, setSearchOnMessages] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  
  // ✅ ESTADO PARA BÚSQUEDA GLOBAL
  const [globalSearchResults, setGlobalSearchResults] = useState(null);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  
  // ✅ ESTADO PARA FILTROS
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [filterResults, setFilterResults] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [tagFilterAnchorEl, setTagFilterAnchorEl] = useState(null);
  const [queueFilterAnchorEl, setQueueFilterAnchorEl] = useState(null);
  
  // ✅ ESTADO PARA CONTROLAR QUÉ BOTÓN DE ACCESO RÁPIDO ESTÁ ACTIVO
  const [activeQuickButton, setActiveQuickButton] = useState("open"); // "open", "closed", "all", "new", "resolve", "sort"
  const [closeTicketsOption, setCloseTicketsOption] = useState("open"); // "open", "pending", "both" - Opción seleccionada para cerrar tickets

  // ✅ OBTENER SOCKET MANAGER EN EL NIVEL SUPERIOR
  const socketManager = useContext(SocketContext);

  // ✅ ESCUCHAR EVENTOS DE SOCKET PARA ACTUALIZAR CONTADORES EN TIEMPO REAL
  useEffect(() => {
    let isMounted = true; // ✅ FLAG PARA EVITAR MEMORY LEAKS
    
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const handleTicketUpdate = (data) => {
      if (!isMounted) return; // ✅ VERIFICAR SI EL COMPONENTE SIGUE MONTADO
      
      if (data.action === "update") {
        // ✅ CORREGIDO: Solo actualizar contadores cuando el ticket cambia de estado
        // No incrementar automáticamente, solo cuando realmente cambia
        // console.log("🔄 Ticket actualizado:", data.ticket.id, "Estado:", data.ticket.status);
      }
      
      if (data.action === "delete") {
        // ✅ CORREGIDO: Reducir contadores basado en el estado anterior del ticket
        // console.log("🗑️ Ticket eliminado:", data.ticketId, "Estado anterior:", data.oldStatus);
        
        if (data.oldStatus === "pending") {
          setPendingCount(prev => Math.max(0, prev - 1));
        }
        if (data.oldStatus === "open") {
          setOpenCount(prev => Math.max(0, prev - 1));
        }
      }

      if (data.action === "create") {
        // ✅ CORREGIDO: Incrementar contador solo cuando se crea un ticket nuevo
        // console.log("➕ Ticket creado:", data.ticket.id, "Estado:", data.ticket.status);
        
        if (data.ticket.status === "pending") {
          setPendingCount(prev => prev + 1);
        }
        if (data.ticket.status === "open") {
          setOpenCount(prev => prev + 1);
        }
      }
    };

    if (socket) {
      socket.on(`company-${companyId}-ticket`, handleTicketUpdate);
    }

    return () => {
      isMounted = false; // ✅ MARCAR COMO DESMONTADO
      if (socket) {
        socket.off(`company-${companyId}-ticket`, handleTicketUpdate);
      }
    };
  }, [socketManager]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  // ✅ SINCRONIZAR ESTADO DEL BOTÓN ACTIVO CON LA PESTAÑA PRINCIPAL
  useEffect(() => {
    setActiveQuickButton(tab); // ✅ SINCRONIZAR CON PESTAÑA PRINCIPAL
  }, [tab]);

  // ✅ CARGAR TAGS AL MONTAR
  useEffect(() => {
    const loadTags = async () => {
      const companyId = user?.companyId;
      if (!companyId) return;
      try {
        const { data } = await api.get(`/tags/list`, { params: { companyId } });
        setTags(data || []);
      } catch (err) {
        console.error("Error cargando tags:", err);
      }
    };
    loadTags();
  }, [user?.companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ APLICAR FILTROS CUANDO CAMBIAN (con debounce)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Si hay búsqueda global activa, no aplicar filtros (prioridad a búsqueda)
      if (globalSearchResults) {
        setFilterResults(null);
        return;
      }
      
      // ✅ Verificar si hay filtros REALES (no valores por defecto)
      const hasQueueFilter = selectedQueueIds?.length > 0;
      const hasTagFilter = selectedTagIds?.length > 0;
      const hasFilters = hasQueueFilter || hasTagFilter;
      
      if (!hasFilters) {
        setFilterResults(null);
        return;
      }
      
      setFilterLoading(true);
      const params = {};
      if (hasQueueFilter) {
        params.queueIds = JSON.stringify(selectedQueueIds);
      }
      if (hasTagFilter) {
        params.tagIds = JSON.stringify(selectedTagIds);
      }
      
      api.get("/tickets/filter-global", { params })
        .then(({ data }) => {
          setFilterResults(data);
          setFilterLoading(false);
        })
        .catch((error) => {
          console.error("❌ Error en filtrado global:", error);
          console.error("❌ Error response:", error.response?.data);
          setFilterLoading(false);
          setFilterResults(null);
        });
    }, 300); // Debounce de 300ms
    
    return () => clearTimeout(timeoutId);
  }, [selectedQueueIds, selectedTagIds, globalSearchResults]);

  let searchTimeout;


  // ✅ FUNCIONES PARA EL BUSCADOR Y BOTONES DE ACCESO RÁPIDO
  const handleNewSearch = async (e) => {
    const searchedTerm = e.target.value.toLowerCase();
    setLocalSearchParam(searchedTerm);

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setLocalSearchParam("");
      setSearchParam("");
      setGlobalSearchResults(null);
      setGlobalSearchLoading(false);
      // ✅ Si hay filtros activos, volver a aplicarlos
      if ((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) {
        // Se aplicarán automáticamente por el useEffect de filtros
      }
      return;
    }

    searchTimeout = setTimeout(async () => {
      // ✅ LLAMAR A API DE BÚSQUEDA GLOBAL
      setGlobalSearchLoading(true);
      try {
        const { data } = await api.get("/tickets/search-global", {
          params: {
            searchParam: searchedTerm,
            searchOnMessages: searchOnMessages ? "true" : "false"
          }
        });
        
        setGlobalSearchResults(data);
        setGlobalSearchLoading(false);
        // ✅ Limpiar filtros cuando hay búsqueda activa
        setFilterResults(null);
      } catch (error) {
        console.error("❌ Error en búsqueda global:", error);
        setGlobalSearchLoading(false);
        setGlobalSearchResults(null);
        // ✅ FALLBACK: Usar búsqueda normal si falla la global
        setSearchParam(searchedTerm);
      }
    }, 500);
  };

  const handleShowAllTickets = () => {
    setShowAllTickets(!showAllTickets);
    
    if (!showAllTickets) {
      // ✅ ACTIVAR VISTA "TODOS" - Cambiar a pestaña "all"
      setTab("open"); // Mantener en pestaña principal "open"
      setTabOpen("all"); // Cambiar a pestaña interna "all"
      setActiveQuickButton("all");
    } else {
      // ✅ DESACTIVAR VISTA "TODOS" - Volver a vista normal
      setTab("open");
      setTabOpen("open"); // Volver a pestaña "open"
      setActiveQuickButton("open");
    }
  };

  const handleNewTicket = () => {
    setNewTicketModalOpen(true); // ✅ ABRIR MODAL PARA CREAR NUEVO TICKET
  };

  const handleResolveTickets = () => {
    setConfirmationModalOpen(true); // ✅ MOSTRAR MODAL DE CONFIRMACIÓN
  };

  // ✅ FUNCIÓN PARA VERIFICAR SI HAY TICKETS PARA CERRAR
  const hasTicketsToClose = () => {
    if (closeTicketsOption === "open") {
      return openCount > 0;
    } else if (closeTicketsOption === "pending") {
      return pendingCount > 0;
    } else if (closeTicketsOption === "both") {
      return (openCount + pendingCount) > 0;
    }
    return false;
  };

  // ✅ FUNCIÓN PARA CONFIRMAR CERRAR TODOS LOS TICKETS
  const handleConfirmCloseAllTickets = async () => {
    // ✅ VALIDACIÓN DE SEGURIDAD: Verificar que hay tickets para cerrar
    if (!hasTicketsToClose()) {
      console.warn("⚠️ No hay tickets para cerrar según la opción seleccionada");
      return; // ✅ NO HACER NADA SI NO HAY TICKETS
    }

    console.log("🎮 CONFIRMANDO CERRAR TODOS LOS TICKETS - Opción seleccionada:", closeTicketsOption);
    setConfirmationModalOpen(false); // ✅ CERRAR MODAL
    
    try {
      // ✅ DETERMINAR QUÉ STATUS CERRAR SEGÚN LA OPCIÓN SELECCIONADA
      let statusesToClose = [];
      
      if (closeTicketsOption === "open") {
        statusesToClose = ["open"];
      } else if (closeTicketsOption === "pending") {
        statusesToClose = ["pending"];
      } else if (closeTicketsOption === "both") {
        statusesToClose = ["open", "pending"];
      }
      
      // ✅ FILTRAR STATUS QUE REALMENTE TIENEN TICKETS
      const statusesWithTickets = statusesToClose.filter(status => {
        if (status === "open") return openCount > 0;
        if (status === "pending") return pendingCount > 0;
        return false;
      });

      // ✅ SI NO HAY TICKETS EN NINGÚN STATUS, NO HACER NADA
      if (statusesWithTickets.length === 0) {
        console.warn("⚠️ No hay tickets para cerrar en ningún status seleccionado");
        return;
      }
      
      console.log("🎮 CERRANDO TICKETS CON STATUS:", statusesWithTickets);
      
      // ✅ CERRAR TICKETS PARA CADA STATUS SELECCIONADO QUE TENGA TICKETS
      const closePromises = statusesWithTickets.map(status => 
        api.post("/tickets/closeAll", { status })
      );
      
      await Promise.all(closePromises);
      
      console.log("✅ TODOS LOS TICKETS CERRADOS EXITOSAMENTE");
      
      // ✅ ACTUALIZAR CONTADORES
      if (closeTicketsOption === "open" || closeTicketsOption === "both") {
        setOpenCount(0);
      }
      if (closeTicketsOption === "pending" || closeTicketsOption === "both") {
        setPendingCount(0);
      }
      
      // ✅ CAMBIAR A PESTAÑA DE CERRADOS PARA VER EL RESULTADO
      setTab("closed");
      setActiveQuickButton("closed");
      
    } catch (error) {
      console.error("❌ ERROR AL CERRAR TICKETS:", error);
      // ✅ AQUÍ PODRÍAS AGREGAR UN TOAST DE ERROR SI LO DESEAS
    }
  };

  const handleOpenTickets = () => {
    setTab("open"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "ABIERTOS"
    setActiveQuickButton("open"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };

  const handleClosedTickets = () => {
    setTab("closed"); // ✅ CAMBIAR A PESTAÑA PRINCIPAL "RESUELTOS"
    setActiveQuickButton("closed"); // ✅ MARCAR BOTÓN COMO ACTIVO
  };


  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  // ✅ FUNCIÓN PARA NAVEGAR A UN TICKET DESDE FILTROS/BÚSQUEDA
  const handleSelectTicket = (ticket) => {
    if (ticket && ticket.uuid) {
      history.push(`/tickets/${ticket.uuid}`);
    } else if (ticket && ticket.id) {
      history.push(`/tickets/${ticket.id}`);
    }
  };

  // ✅ COMENTADO: handleChangeTab ya no se usa porque las pestañas principales están ocultas
  // const handleChangeTab = (e, newValue) => {
  //   setTab(newValue);
  // };

  const applyPanelStyle = (status) => {
    // ✅ Permitir que siempre mantengan su tamaño natural para el scroll
    // Solo controlar la visibilidad con display en el div padre
    return {
      height: "100%",
      width: "100%"
    };
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };


  const handleCloseTransferModal = () => {
    setTransferTicketModalOpen(false);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          
          handleCloseOrOpenTicket(ticket);
        }}
      />
      {/* ✅ PESTAÑAS PRINCIPALES - OCULTADAS PARA USAR BOTONES DE ACCESO RÁPIDO */}
      {/* 
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="scrollable" // ✅ NUEVO: Permitir scroll horizontal para pestañas principales
          scrollButtons="auto" // ✅ NUEVO: Mostrar botones de scroll automáticamente cuando sea necesario
          aria-label="scrollable main tabs" // ✅ NUEVO: Accesibilidad
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<LockIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      */}

      {/* ✅ BUSCADOR DE TICKETS Y MENSAJES */}
      <div className={classes.searchInputWrapperNew}>
        <SearchIcon className={classes.searchIconNew} />
        <InputBase
          className={classes.searchInputNew}
          placeholder="Buscar tickets y mensajes"
          type="search"
          value={localSearchParam}
          onChange={handleNewSearch}
        />
        <Tooltip placement="top" title="Buscar también en el contenido de los mensajes (más lento)">
          <div>
            <Switch
              size="small"
              className={classes.searchSwitchNew}
              checked={searchOnMessages}
              onChange={(e) => setSearchOnMessages(e.target.checked)}
            />
          </div>
        </Tooltip>
      </div>

      {/* ✅ BARRA DE HERRAMIENTAS CON 6 BOTONES DE ACCESO RÁPIDO */}
      <div className={classes.quickActionsBar}>
        <div className={classes.quickActionsLeft}>
          {/* Botón 1: Todos */}
          <ToggleButton
            value="showAll"
            selected={showAllTickets}
            onChange={handleShowAllTickets}
            className={classes.quickActionButton}
            size="small"
          >
            {showAllTickets ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </ToggleButton>

          {/* Botón 2: Nuevo */}
          <Tooltip title="Crear nuevo ticket">
            <IconButton
              onClick={handleNewTicket}
              className={classes.quickActionIconButton}
              size="small"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>

          {/* Botón 3: Resolver */}
          <Tooltip title="Resolver tickets">
            <IconButton
              onClick={handleResolveTickets}
              className={classes.quickActionIconButton}
              size="small"
            >
              <CheckBoxIcon />
            </IconButton>
          </Tooltip>

          {/* Botón 4: Abiertos */}
          <Tooltip title="Mostrar tickets abiertos">
            <ToggleButton
              value="open"
              selected={activeQuickButton === "open"}
              onChange={handleOpenTickets}
              className={classes.quickActionButton}
              size="small"
            >
              <MoveToInboxIcon />
            </ToggleButton>
          </Tooltip>

          {/* Botón 5: Cerrados */}
          <Tooltip title="Mostrar tickets cerrados">
            <ToggleButton
              value="closed"
              selected={activeQuickButton === "closed"}
              onChange={handleClosedTickets}
              className={classes.quickActionButton}
              size="small"
            >
              <LockIcon />
            </ToggleButton>
          </Tooltip>
        </div>

        <div className={classes.quickActionsRight}>
          {/* ✅ NUEVO: Botón de filtro de departamentos con icono (similar a otros botones rápidos) */}
          <Tooltip title="Filtrar por departamentos">
            <IconButton
              onClick={(e) => {
                setQueueFilterAnchorEl(e.currentTarget);
              }}
              className={classes.quickActionIconButton}
              size="small"
              style={{ 
                position: 'relative',
                backgroundColor: selectedQueueIds?.length > 0 ? theme.palette.primary.main : undefined,
                color: selectedQueueIds?.length > 0 ? '#fff' : undefined
              }}
            >
              <BusinessIcon />
              {selectedQueueIds?.length > 0 && (
                <Chip 
                  label={selectedQueueIds.length} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: selectedQueueIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                    color: selectedQueueIds?.length > 0 ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar departamentos */}
          <Menu
            anchorEl={queueFilterAnchorEl}
            open={Boolean(queueFilterAnchorEl)}
            onClose={() => setQueueFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {user?.queues?.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary="No hay departamentos disponibles"
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {user?.queues?.map(queue => (
              <MenuItem
                key={queue.id}
                dense
                onClick={() => {
                  const isSelected = selectedQueueIds.indexOf(queue.id) > -1;
                  if (isSelected) {
                    setSelectedQueueIds(prev => prev.filter(id => id !== queue.id));
                  } else {
                    setSelectedQueueIds(prev => [...prev, queue.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: queue.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText 
                  primary={queue.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón de filtro de etiquetas con icono (similar a otros botones rápidos) */}
          <Tooltip title="Filtrar por etiquetas">
            <IconButton
              onClick={(e) => {
                setTagFilterAnchorEl(e.currentTarget);
              }}
              className={classes.quickActionIconButton}
              size="small"
              style={{ 
                position: 'relative',
                backgroundColor: selectedTagIds?.length > 0 ? theme.palette.primary.main : undefined,
                color: selectedTagIds?.length > 0 ? '#fff' : undefined
              }}
            >
              <LocalOfferIcon />
              {selectedTagIds?.length > 0 && (
                <Chip 
                  label={selectedTagIds.length} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: selectedTagIds?.length > 0 ? '#fff' : theme.palette.primary.main,
                    color: selectedTagIds?.length > 0 ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
          
          {/* ✅ NUEVO: Menú desplegable para seleccionar etiquetas */}
          <Menu
            anchorEl={tagFilterAnchorEl}
            open={Boolean(tagFilterAnchorEl)}
            onClose={() => setTagFilterAnchorEl(null)}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 250,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              },
            }}
          >
            {tags.length === 0 && (
              <MenuItem disabled>
                <ListItemText 
                  primary="No hay etiquetas disponibles"
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.secondary, fontStyle: 'italic' }
                  }}
                />
              </MenuItem>
            )}
            {tags.map(tag => (
              <MenuItem
                key={tag.id}
                dense
                onClick={() => {
                  const isSelected = selectedTagIds.indexOf(tag.id) > -1;
                  if (isSelected) {
                    setSelectedTagIds(prev => prev.filter(id => id !== tag.id));
                  } else {
                    setSelectedTagIds(prev => [...prev, tag.id]);
                  }
                }}
              >
                <Checkbox
                  style={{ color: tag.color || theme.palette.primary.main }}
                  size="small"
                  checked={selectedTagIds.indexOf(tag.id) > -1}
                />
                <ListItemText 
                  primary={tag.name}
                  primaryTypographyProps={{
                    style: { color: theme.palette.text.primary }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
          
          {/* ✅ NUEVO: Botón para abrir panel de filtros */}
          <Tooltip title="Ver filtros activos">
            <IconButton
              size="small"
              onClick={() => setFilterPanelOpen(!filterPanelOpen)}
              className={classes.quickActionIconButton}
              style={{ 
                backgroundColor: filterPanelOpen ? theme.palette.primary.main : undefined,
                color: filterPanelOpen ? '#fff' : undefined,
                position: 'relative'
              }}
            >
              <FilterListIcon />
              {((selectedQueueIds?.length > 0) || (selectedTagIds?.length > 0)) && (
                <Chip 
                  label={(selectedQueueIds?.length || 0) + (selectedTagIds?.length || 0)} 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 4, 
                    right: 4,
                    height: '16px',
                    fontSize: '0.65rem',
                    minWidth: '18px',
                    backgroundColor: filterPanelOpen ? '#fff' : theme.palette.primary.main,
                    color: filterPanelOpen ? theme.palette.primary.main : '#fff'
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* ✅ NUEVO: Panel de filtros */}
      <FilterPanel
        open={filterPanelOpen}
        onToggle={() => setFilterPanelOpen(!filterPanelOpen)}
        selectedQueueIds={selectedQueueIds}
        selectedTagIds={selectedTagIds}
        queues={user?.queues}
        tags={tags}
        onClearFilters={() => {
          setSelectedQueueIds([]);
          setSelectedTagIds([]);
        }}
        onRemoveQueue={(queueId) => {
          setSelectedQueueIds(prev => prev.filter(id => id !== queueId));
        }}
        onRemoveTag={(tagId) => {
          setSelectedTagIds(prev => prev.filter(id => id !== tagId));
        }}
      />

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable" // ✅ CAMBIADO: De "fullWidth" a "scrollable" para permitir scroll horizontal
          scrollButtons="auto" // ✅ NUEVO: Mostrar botones de scroll automáticamente cuando sea necesario
          aria-label="scrollable tabs" // ✅ NUEVO: Accesibilidad
        >
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={openCount}
                color="primary"
              >
                {i18n.t("ticketsList.assignedHeader")}
              </Badge>
            }
            value={"open"}
          />
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={pendingCount}
                color="secondary"
              >
                {i18n.t("ticketsList.pendingHeader")}
              </Badge>
            }
            value={"pending"}
          />
          {/* ✅ NUEVA PESTAÑA: TODOS (solo cuando showAllTickets = true) */}
          {showAllTickets && (
            <Tab
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={allTicketsCount}
                  color="default"
                >
                  {i18n.t("ticketsList.allHeader")}
                </Badge>
              }
              value={"all"}
            />
          )}
          {/* ✅ NUEVA PESTAÑA: GRUPOS (solo si user.allowGroup = true) */}
          {user.allowGroup && (
            <Tab
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={groupsCount}
                  color="secondary"
                >
                  GRUPOS
                </Badge>
              }
              value={"groups"}
            />
          )}
          {/* ✅ NUEVA PESTAÑA: AGENTES IA */}
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={aiAgentsCount}
                color="primary"
              >
                AGENTES IA
              </Badge>
            }
            value={"ai-agents"}
          />
        </Tabs>
        <div className={classes.ticketsContainer}>
          {/* ✅ BÚSQUEDA GLOBAL: Mostrar resultados agrupados si hay búsqueda activa */}
          {globalSearchResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={globalSearchResults}
                searchParam={localSearchParam}
                loading={globalSearchLoading}
                onTicketClick={handleSelectTicket}
              />
            </div>
          )}
          
          {/* ✅ FILTROS: Mostrar resultados filtrados si hay filtros activos (solo si no hay búsqueda) */}
          {!globalSearchResults && filterResults && (
            <div style={{ 
              flex: "none",
              maxHeight: "60%",
              overflowY: "auto",
              marginBottom: 8,
              padding: "0 8px"
            }}>
              <SearchResultsPanel
                results={filterResults}
                searchParam=""
                loading={filterLoading}
                onTicketClick={handleSelectTicket}
                isFilterMode={true}
              />
            </div>
          )}
          
          {/* ✅ RENDERIZAR SIEMPRE AMBOS COMPONENTES PARA MANTENER CONTADORES ACTUALIZADOS */}
          <div style={{ 
            display: tabOpen === "open" ? "flex" : "none",
            flex: 1,
            height: "100%",
            flexDirection: "column",
            minHeight: 0
          }}>
            <TicketsListCustom
              status="open"
              showAll={user?.profile === "admin"} // ✅ CORRECCIÓN 2025-12-23: Solo admin puede ver todos los tickets
              selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
              updateCount={(val) => setOpenCount(val)}
              style={applyPanelStyle("open")}
              searchOnMessages={searchOnMessages}
              searchParam={globalSearchResults ? "" : (tabOpen === "open" ? searchParam : "")}
              isActiveTab={tabOpen === "open"}
              excludeAIAgents={true} // ✅ NUEVO: Excluir tickets con IA de ATENDIENDO
            />
          </div>
          <div style={{ 
            display: tabOpen === "pending" ? "flex" : "none",
            flex: 1,
            height: "100%",
            flexDirection: "column",
            minHeight: 0
          }}>
            <TicketsListCustom
              status="pending"
              selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
              updateCount={(val) => setPendingCount(val)}
              style={applyPanelStyle("pending")}
              searchOnMessages={searchOnMessages}
              searchParam={tabOpen === "pending" ? searchParam : ""}
              isActiveTab={tabOpen === "pending"}
              excludeAIAgents={true} // ✅ NUEVO: Excluir tickets con IA de PENDING
            />
          </div>
          {/* ✅ NUEVO CONTENEDOR: TODOS (solo cuando showAllTickets = true) */}
          {showAllTickets && (
            <div style={{ 
              display: tabOpen === "all" ? "flex" : "none",
              flex: 1,
              height: "100%",
              flexDirection: "column",
              minHeight: 0
            }}>
              <TicketsListCustom
                status="all"
                showAll={true}
                selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
                updateCount={(val) => setAllTicketsCount(val)}
                style={applyPanelStyle("all")}
                searchOnMessages={searchOnMessages}
                searchParam={tabOpen === "all" ? searchParam : ""}
                isActiveTab={tabOpen === "all"}
              />
            </div>
          )}
          {/* ✅ NUEVO CONTENEDOR: GRUPOS */}
          {user.allowGroup && (
            <div style={{ 
              display: tabOpen === "groups" ? "flex" : "none",
              flex: 1,
              height: "100%",
              flexDirection: "column",
              minHeight: 0
            }}>
              <TicketsListCustom
                status="group"
                selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
                updateCount={(val) => setGroupsCount(val)}
                style={applyPanelStyle("groups")}
                searchOnMessages={searchOnMessages}
                searchParam={tabOpen === "groups" ? searchParam : ""}
                isActiveTab={tabOpen === "groups"}
              />
            </div>
          )}
          {/* ✅ NUEVO CONTENEDOR: AGENTES IA */}
          <div style={{ 
            display: tabOpen === "ai-agents" ? "flex" : "none",
            flex: 1,
            height: "100%",
            flexDirection: "column",
            minHeight: 0
          }}>
            <TicketsListCustom
              status="ai"
              selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
              updateCount={(val) => setAiAgentsCount(val)}
              style={applyPanelStyle("ai-agents")}
              aiAgentFilter={true}
              excludeAIAgents={false} // ✅ NUEVO: Explícitamente false para pestaña IA
              searchOnMessages={searchOnMessages}
              searchParam={tabOpen === "ai-agents" ? searchParam : ""}
              isActiveTab={tabOpen === "ai-agents"}
            />
          </div>
        </div>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsListCustom
          status="closed"
          showAll={true}
          selectedQueueIds={filterResults ? selectedQueueIds : undefined} // ✅ Si no hay filtros activos, no pasar queueIds
          searchOnMessages={searchOnMessages}
          searchParam={tab === "closed" ? searchParam : ""}
          isActiveTab={tab === "closed"}
        />
      </TabPanel>
      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferModal}
        ticketid={null}
      />
      
      {/* ✅ MODAL DE CONFIRMACIÓN MEJORADO PARA CERRAR TODOS LOS TICKETS */}
      <ConfirmationModal
        title={i18n.t("ticketsManager.confirmation.title")}
        open={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false);
          setCloseTicketsOption("open"); // ✅ Resetear opción al cerrar
        }}
        onConfirm={handleConfirmCloseAllTickets}
        confirmDisabled={!hasTicketsToClose()} // ✅ DESHABILITAR SI NO HAY TICKETS
        maxWidth="sm"
        fullWidth
      >
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
          {/* ✅ ICONO DE ALERTA GRANDE */}
          <WarningIcon 
            style={{ 
              fontSize: 64, 
              color: '#ff9800', 
              marginBottom: 16 
            }} 
          />
          
          {/* ✅ TÍTULO PRINCIPAL */}
          <Typography 
            variant="h6" 
            component="h2" 
            align="center" 
            gutterBottom
            style={{ 
              fontWeight: 'bold', 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f' 
            }}
          >
            {i18n.t("ticketsManager.confirmation.title")}
          </Typography>
          
          {/* ✅ SUBTÍTULO EXPLICATIVO */}
          <Typography 
            variant="body1" 
            align="center" 
            gutterBottom
            style={{ 
              marginBottom: 16, 
              color: theme.palette.text.secondary || theme.palette.text.primary 
            }}
          >
            {i18n.t("ticketsManager.confirmation.subtitle")}
          </Typography>
          
          {/* ✅ PREGUNTA PRINCIPAL */}
          <Typography 
            variant="body1" 
            align="center" 
            gutterBottom
            style={{ 
              fontWeight: 'bold', 
              marginBottom: 16,
              color: theme.palette.text.primary
            }}
          >
            ¿Qué tickets deseas cerrar?
          </Typography>

          {/* ✅ MENSAJE INFORMATIVO SI NO HAY TICKETS */}
          {!hasTicketsToClose() && (
            <Box
              style={{
                padding: '12px 16px',
                marginBottom: 16,
                borderRadius: '8px',
                backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#e3f2fd',
                border: `1px solid ${theme.mode === 'dark' ? '#3b82f6' : '#90caf9'}`,
                textAlign: 'center'
              }}
            >
              <Typography 
                variant="body2" 
                style={{ 
                  color: theme.mode === 'dark' ? '#93c5fd' : '#1565c0',
                  fontWeight: '500'
                }}
              >
                <span role="img" aria-label="advertencia">⚠️</span> No hay tickets para cerrar según la opción seleccionada
              </Typography>
            </Box>
          )}
          
          {/* ✅ OPCIONES DE SELECCIÓN */}
          <FormControl component="fieldset" style={{ width: '100%', marginBottom: 16 }}>
            <RadioGroup
              value={closeTicketsOption}
              onChange={(e) => setCloseTicketsOption(e.target.value)}
              style={{ width: '100%' }}
            >
              <Box
                onClick={() => setCloseTicketsOption("open")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "open" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#e3f2fd')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "open") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="open" 
                  control={<Radio style={{ color: theme.palette.primary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>ATENDIENDO (Abiertos)</span>
                      <Badge badgeContent={openCount} color="primary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("pending")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "pending" 
                    ? (theme.mode === 'dark' ? '#4B5563' : '#fce4ec')
                    : (theme.mode === 'dark' ? '#374151' : '#fff'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "pending") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                  }
                }}
              >
                <FormControlLabel 
                  value="pending" 
                  control={<Radio style={{ color: theme.palette.secondary.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary }}>PENDIENTE</span>
                      <Badge badgeContent={pendingCount} color="secondary" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
              <Box
                onClick={() => setCloseTicketsOption("both")}
                style={{ 
                  marginBottom: 8, 
                  padding: '12px', 
                  border: `1px solid ${closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#dc2626' : '#ff9800')
                    : (theme.mode === 'dark' ? '#7c2d12' : '#ff9800')}`,
                  borderRadius: '8px',
                  backgroundColor: closeTicketsOption === "both" 
                    ? (theme.mode === 'dark' ? '#991b1b' : '#fff3e0')
                    : (theme.mode === 'dark' ? '#78350f' : '#fff3e0'),
                  transition: 'all 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#991b1b' : '#ffe0b2';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#dc2626' : '#ff9800';
                  }
                }}
                onMouseLeave={(e) => {
                  if (closeTicketsOption !== "both") {
                    e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#78350f' : '#fff3e0';
                    e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#7c2d12' : '#ff9800';
                  }
                }}
              >
                <FormControlLabel 
                  value="both" 
                  control={<Radio style={{ color: theme.palette.error.main }} />} 
                  label={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>AMBOS (ATENDIENDO + PENDIENTE)</span>
                      <Badge badgeContent={openCount + pendingCount} color="error" style={{ marginLeft: 16 }} />
                    </Box>
                  }
                  style={{ margin: 0, width: '100%' }}
                />
              </Box>
            </RadioGroup>
          </FormControl>
          
          {/* ✅ ADVERTENCIA FINAL */}
          <Typography 
            variant="body2" 
            align="center"
            style={{ 
              color: theme.mode === 'dark' ? '#f87171' : '#d32f2f', 
              fontWeight: 'bold',
              backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
              padding: '8px 16px',
              borderRadius: '4px',
              border: `1px solid ${theme.mode === 'dark' ? '#7f1d1d' : '#ffcdd2'}`
            }}
          >
            {i18n.t("ticketsManager.confirmation.warning")}
          </Typography>
        </Box>
      </ConfirmationModal>

      {/* ✅ ELIMINADO: Modal de corrección de duplicados - Ya no se usa */}
    </Paper>
  );
};

export default TicketsManagerTabs;
